import * as Sentry from "@sentry/react"
import { Button } from "@/components/ui/button"

interface FallbackProps {
  error: Error
  resetError: () => void
}

const ErrorFallback = ({ error, resetError }: FallbackProps) => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-4">
      <div className="max-w-md text-center">
        <h1 className="mb-2 text-2xl font-bold text-destructive">
          Algo deu errado
        </h1>
        <p className="mb-4 text-muted-foreground">
          Ocorreu um erro inesperado. Nossa equipe foi notificada.
        </p>
        {import.meta.env.MODE === "development" && (
          <pre className="mb-4 max-h-40 overflow-auto rounded bg-muted p-4 text-left text-xs">
            {error.message}
          </pre>
        )}
        <div className="flex justify-center gap-2">
          <Button onClick={resetError}>Tentar novamente</Button>
          <Button variant="outline" onClick={() => (window.location.href = "/")}>
            Voltar ao início
          </Button>
        </div>
      </div>
    </div>
  )
}

interface ErrorBoundaryProps {
  children: React.ReactNode
}

export const ErrorBoundary = ({ children }: ErrorBoundaryProps) => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorFallback error={error as Error} resetError={resetError} />
      )}
      onError={(error) => {
        console.error("[ErrorBoundary] Captured error:", error)
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
